import { useState, useEffect } from "react";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton"
import { Alert, CircularProgress, Checkbox, FormControlLabel, Modal, Snackbar, Box, RadioGroup, Radio, FormControl, FormLabel } from "@mui/material";
import servAnalises from "../../../services/login/servAnalises";
import servSolAcessoSolDec from "../../../services/login/servSolAcessoSolDec";


const EnviarSolicAnalise = ({ setOpenPopup, recordForEdit, codeSolAcesso, codeRespTecnico, pesquisar, setOpen }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [openSuccessWindow, setOpenSuccessWindow] = useState(false);
    const [isEncontrado, setIsEncontrado] = useState(false);
    const [declaracoes, setDeclaracoes] = useState({
        Declaracao1Descricao: "Solicito que a contagem do prazo para realização da vistoria pela distribuidora, conforme art. 68 da Resolução Normativa nº 1.000/2021, inicie-se somente após minha solicitação.",
        Declaracao1: false,
        Declaracao2Descricao: "Renuncio ao direito de desistir do orçamento de conexão nos termos dos §§ 7º e 8º do art. 89 da Resolução Normativa nº 1.000/2021.",
        Declaracao2: false,
        Declaracao3Descricao: "Autorizo a distribuidora a entregar junto com o orçamento de conexão os contratos e o documento ou meio para pagamento de custos de minha responsabilidade.",
        Declaracao3: false,
        Declaracao4Descricao: "Declaro que as instalações internas da minha unidade consumidora, incluindo a geração distribuída, atendem às normas e padrões da distribuidora, às normas da Associação Brasileira de Normas Técnicas - ABNT e às normas dos órgãos oficiais competentes, e ao art. 8º da Lei nº9.074, de 1995, naquilo que for aplicável.",
        Declaracao4: false,
        Assinado: false,
        CodigoSolicitacaoAcesso: 0,
        CodigoResponsavelTecnico: 0,
        Declaracao5: false,
        Declaracao5Descricao: 'Solicito a dispensa da análise de inversão de fluxo, conforme o enquadramento no art. 73-A, de acordo com a seguinte regra:',
        Declaracao51: false,
        Declaracao51Descricao: 'Não injeção na rede de distribuição de energia elétrica ("Grid zero").',
        Declaracao52: false,
        Declaracao52Descricao: 'Enquadramento nos critérios de gratuidade da REN 1.000/2021 e potência de geração compatível com o consumo no horário de geração.',
        Declaracao53: false,
        Declaracao53Descricao: 'Modalidade autoconsumo local, com potência instalada de geração igual ou inferior a 7,5 KW, observado o item 6.',
        Declaracao6: false,
        Declaracao6Descricao: 'Declaro, para todos os fins, que todas as informações prestadas neste documento são verdadeiras.',
        selectedRadio: ""
    });

    useEffect(() => {
        async function fetchData() {
            if (!recordForEdit) {
                recordForEdit = {
                    Id: codeSolAcesso,
                    CodigoResponsavelTec: codeRespTecnico
                }
            }

            try {
                let codigoSolicitacaoAcesso = recordForEdit?.row?.Id || recordForEdit?.Id;
                let codigoResponsavelTecnico = recordForEdit?.row?.CodigoResponsavelTec || recordForEdit?.CodigoResponsavelTec

                const response = await servSolAcessoSolDec.RecuperarSolicitacoesDeclaracoes(codigoSolicitacaoAcesso);
                setIsEncontrado(response.Content.Encontrado);

                if (response.Content.Encontrado) {
                    const dadosApi = response.Content.SolAcessoSolDec;

                    let selectedRadio = "";
                    if (dadosApi.Declaracao51) selectedRadio = "option1";
                    else if (dadosApi.Declaracao52) selectedRadio = "option2";
                    else if (dadosApi.Declaracao53) selectedRadio = "option3";

                    setDeclaracoes((prev) => ({
                        ...prev,
                        ...dadosApi,
                        selectedRadio,
                    }));
                } else {
                    setDeclaracoes((prev) => ({
                        ...prev,
                        CodigoResponsavelTecnico: codigoResponsavelTecnico,
                        CodigoSolicitacaoAcesso: codigoSolicitacaoAcesso,
                    }));
                }
            } catch (err) {
                setErrorMessage("Erro ao buscar solicitações: " + err.message);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, [recordForEdit]);

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenSuccessWindow(false);
        }

        setOpenSuccessWindow(false);
    }

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const solicitarAnalise = async () => {
        if (declaracoes.CodigoResponsavelTecnico === 0) {
            setOpenErrorWindow(true);
            setErrorMessage("Solicitação não encontrada. Atualize a página e tente novamente. Se o problema persistir, entre em contato com nossa equipe de suporte.");

            return;
        }
        try {
            setIsLoading(true);

            if (isEncontrado) {
                let dto = { Id: declaracoes.Id, Declaracao: declaracoes };

                await servSolAcessoSolDec.Editar(dto);
            }

            if (!isEncontrado) {
                if (declaracoes.Declaracao4) {
                    declaracoes.Assinado = true;
                }

                await servSolAcessoSolDec.Inserir(declaracoes);
            }

            await servAnalises.EnviarParaAnalise(declaracoes.CodigoSolicitacaoAcesso);

            setOpenSuccessWindow(true);
            setSuccessMessage("Solicitação enviada para análise com sucesso.");

            setIsLoading(false);

            setTimeout(() => {
                setOpenPopup(false);
                if (typeof setOpen === 'function') setOpen(false);
                pesquisar?.();
            }, 800);
        } catch (err) {
            setIsLoading(false);

            setErrorMessage(err?.response?.data?.Message);
            return setOpenErrorWindow(true);
        }
    }

    const handleRadioChange = (event) => {
        const selectedValue = event.target.value;

        setDeclaracoes((prev) => {
            const newSelectedRadio = prev.selectedRadio === selectedValue ? "" : selectedValue;
            return {
                ...prev,
                selectedRadio: newSelectedRadio,
                Declaracao51: newSelectedRadio === "option1" ? !prev.Declaracao51 : false,
                Declaracao52: newSelectedRadio === "option2" ? !prev.Declaracao52 : false,
                Declaracao53: newSelectedRadio === "option3" ? !prev.Declaracao53 : false,
                Declaracao5: newSelectedRadio !== ""
            };
        });
    };

    return (
        <div style={{ width: "100%", height: "660px", display: "flex", flexDirection: "column" }}>
            <h4>
                Você deseja enviar o orçamento de conexão para análise? <br />
                Após o envio, o orçamento de conexão só poderá ser alterado em um momento de revisão ou reprovação.
            </h4>
            <div style={{ backgroundColor: "#333333", padding: "16px", borderRadius: "8px", flex: 1, overflowY: "auto" }}>
                <h3 style={{ color: "#6D79EC", fontSize: "20px", borderBottom: "1px solid #6D79EC", width: "38%" }}>
                    SOLICITAÇÕES E DECLARAÇÕES
                </h3>
                <div style={{ display: "flex", flexWrap: "wrap", margin: "20px 0px" }}>
                    <FormControlLabel
                        control={<Checkbox
                            sx={{
                                color: '#B8B8B8 !important',
                                margin: '20px 0px',
                                '&.Mui-checked': {
                                    color: '#6D79EC !important',
                                },
                            }}
                            onClick={() => setDeclaracoes((prev) => ({ ...prev, Declaracao1: !prev.Declaracao1 }))}
                            checked={declaracoes.Declaracao1}
                        />
                        }
                        label={
                            <span style={{ color: '#ffffff' }}>
                                {declaracoes.Declaracao1Descricao}
                                <span style={{ fontWeight: 'bold' }}> (Opcional) </span>
                            </span>
                        }
                    />
                    <FormControlLabel
                        control={<Checkbox
                            sx={{
                                color: '#B8B8B8 !important',
                                margin: '20px 0px',
                                '&.Mui-checked': {
                                    color: '#6D79EC !important',
                                }
                            }}
                            onClick={() => setDeclaracoes((prev) => ({ ...prev, Declaracao2: !prev.Declaracao2 }))}
                            checked={declaracoes.Declaracao2}
                        />
                        }
                        label={
                            <span
                                style={{
                                    color: '#ffffff'
                                }}
                            >
                                {declaracoes.Declaracao2Descricao}<span style={{ fontWeight: 'bold' }}> (Opcional) </span>
                            </span>
                        }
                    />

                    <FormControlLabel
                        control={<Checkbox
                            sx={{
                                color: '#B8B8B8 !important',
                                margin: '20px 0px',
                                '&.Mui-checked': {
                                    color: '#6D79EC !important',
                                }
                            }}
                            onClick={() => setDeclaracoes((prev) => ({ ...prev, Declaracao3: !prev.Declaracao3 }))}
                            checked={declaracoes.Declaracao3}
                        />
                        }
                        label={
                            <span
                                style={{
                                    color: '#ffffff'
                                }}
                            >
                                {declaracoes.Declaracao3Descricao}<span style={{ fontWeight: 'bold' }}> (Opcional) </span>
                            </span>
                        }
                    />

                    <FormControlLabel
                        required
                        control={<Checkbox
                            sx={{
                                color: '#B8B8B8 !important',
                                margin: '40px 0px',
                                '&.Mui-checked': {
                                    color: '#6D79EC !important',
                                },
                            }}
                            onClick={() => setDeclaracoes((prev) => ({ ...prev, Declaracao4: !prev.Declaracao4 }))}
                            checked={declaracoes.Declaracao4}
                        />
                        }
                        label={
                            <span
                                style={{
                                    color: '#ffffff'
                                }}
                            >
                                {declaracoes.Declaracao4Descricao}<span style={{ fontWeight: 'bold' }}> (Obrigatório) </span>
                            </span>
                        }
                    />

                    <FormControlLabel
                        required
                        control={
                            <Checkbox
                                disabled={true}
                                sx={{
                                    color: '#B8B8B8 !important',
                                    margin: '10px 0px',
                                    '&.Mui-checked': {
                                        color: '#6D79EC !important',
                                    },
                                }}
                                onClick={() => setDeclaracoes((prev) => ({ ...prev, Declaracao5: !prev.Declaracao5 }))}
                                checked={declaracoes.Declaracao5}
                            />
                        }
                        label={
                            <span style={{ color: '#ffffff' }}>
                                {declaracoes.Declaracao5Descricao}
                                <span style={{ fontWeight: 'bold' }}> (Opcional) </span>
                            </span>
                        }
                    />

                    <FormControl component="fieldset" sx={{ marginLeft: '30px' }}>
                        <FormLabel component="legend" style={{ color: '#ffffff' }}></FormLabel>
                        <RadioGroup value={declaracoes.selectedRadio} onClick={handleRadioChange}>
                            <FormControlLabel
                                style={{ color: '#ffffff' }}
                                value="option1"
                                control={<Radio sx={{ color: '#B8B8B8', '&.Mui-checked': { color: '#6D79EC' } }} />}
                                label={declaracoes.Declaracao51Descricao}
                            />
                            <FormControlLabel
                                style={{ color: '#ffffff' }}
                                value="option2"
                                control={<Radio sx={{ color: '#B8B8B8', '&.Mui-checked': { color: '#6D79EC' } }} />}
                                label={declaracoes.Declaracao52Descricao}
                            />
                            <FormControlLabel
                                style={{ color: '#ffffff' }}
                                value="option3"
                                control={<Radio sx={{ color: '#B8B8B8', '&.Mui-checked': { color: '#6D79EC' } }} />}
                                label={declaracoes.Declaracao53Descricao}
                            />
                        </RadioGroup>
                    </FormControl>

                    <FormControlLabel
                        required
                        control={
                            <Checkbox
                                sx={{
                                    color: '#B8B8B8 !important',
                                    margin: '40px 0px',
                                    '&.Mui-checked': {
                                        color: '#6D79EC !important',
                                    },
                                }}
                                onClick={() => setDeclaracoes((prev) => ({ ...prev, Declaracao6: !prev.Declaracao6 }))}
                                checked={declaracoes.Declaracao6}
                            />
                        }
                        label={
                            <span
                                style={{
                                    color: '#ffffff'
                                }}
                            >
                                {declaracoes.Declaracao6Descricao}<span style={{ fontWeight: 'bold' }}> (Obrigatório) </span>
                            </span>
                        }
                    />
                </div>
            </div>
            <div className="homologacao_consulta">
                <BlueHoverButton onClick={() => setOpenPopup(false)} >Cancelar</BlueHoverButton>
                <BlueHoverButton onClick={solicitarAnalise} >Enviar</BlueHoverButton>
            </div>

            <Snackbar open={openSuccessWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                    {successMessage}
                </Alert>
            </Snackbar>
            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}>
                <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { EnviarSolicAnalise }